import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { addProduct } from '../redux/products/actions';

function ProductForm() {
    //States
    const [formValues, setFormValues] = useState({
        name: "",
        category: "",
        imgURL: "",
        price: "",
        quantity: "",
    });
    //Hooks
    const dispatch = useDispatch();
    //Function
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, category, imgURL, price, quantity } = formValues;
        if (name && category && imgURL && price && quantity) {
            const payload = { name, category, imgURL, price, quantity };
            dispatch(addProduct(payload));
            setFormValues({
                name: "",
                category: "",
                imgURL: "",
                price: "",
                quantity: "",
            });
        }
    };


    //JSX
    return (
        <div>
            <div className="formContainer">
                <h4 className="formTitle">Add New Product</h4>
                <form className="space-y-4 text-[#534F4F]" id="lws-addProductForm" onSubmit={handleSubmit}>
                    <div className="space-y-2">
                        <label for="name">Product Name</label>
                        <input className="addProductInput" id="lws-inputName" type="text" id="name" value={formValues.name} name="name" required onChange={handleInputChange} />
                    </div>
                    <div className="space-y-2">
                        <label for="category">Category</label>
                        <input className="addProductInput" id="lws-inputCategory" type="text" id="category" value={formValues.category} name="category" required onChange={handleInputChange} />
                    </div>
                    <div className="space-y-2">
                        <label for="image">Image Url</label>
                        <input className="addProductInput" id="lws-inputImage" type="text" id="image" value={formValues.imgURL} name="imgURL" required onChange={handleInputChange} />
                    </div>
                    <div className="grid grid-cols-2 gap-8 pb-4">
                        <div className="space-y-2">
                            <label for="price">Price</label>
                            <input className="addProductInput" type="number" id="lws-inputPrice" value={formValues.price} name="price" required min="0" onChange={handleInputChange} />
                        </div>
                        <div className="space-y-2">
                            <label for="quantity">Quantity</label>
                            <input className="addProductInput" type="number" id="lws-inputQuantity" value={formValues.quantity} name="quantity"  min="0" required onChange={handleInputChange} />
                        </div>
                    </div>
                    <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
                </form>
            </div>
        </div>
    )
}

export default ProductForm